import React, { useEffect, useState } from "react"
import Select from "react-select"
import { Controller } from "react-hook-form"

function ucfirst(str) {
  var firstLetter = str.substr(0, 1)
  return firstLetter.toUpperCase() + str.substr(1)
}

const ReferenceType = ({
  control,
  name,
  onSelectChange,
  target,
  placeholder,
  dropView,
  hideOnAccount,
}) => {
  const [isLoading, setIsLoading] = useState(true)
  const [countriesData, setCountriesData] = useState([])

  const loadOptions = async () => {
    const data = [
      { label: "Advance", value: 1 },
      { label: "Against Ref", value: 2 },
      { label: "New Ref", value: 3 },
      { label: "On Account", value: 4 },
    ]

    const filtered = hideOnAccount
      ? data
      : data.filter(d => d.value !== 4)
    setIsLoading(false)
    const countries = filtered.map(dta => {
      return {
        label: dta?.label && ucfirst(dta.label),
        value: dta.value,
        ...dta,
      }
    })

    setCountriesData(countries)
  }

  useEffect(() => {
    loadOptions()
  }, [hideOnAccount])

  return (
    <div>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, ref, value } }) => {
          return (
            <Select
              options={countriesData}
              // placeholder={placeholder ? placeholder : "Select"}
              placeholder={
              <div className="css-placeholder">
                {placeholder || "Select"} 
              </div>
            }
              isLoading={isLoading}
              inputRef={ref}
              onChange={e => {
                onChange(e)
                if (onSelectChange) onSelectChange(e)
              }}
              value={value}
              classNamePrefix="react-select"
              className="elevate-dropdown"
              menuPortalTarget={document.body}
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
              menuPlacement={dropView ? "top" : "bottom"}
              // menuPortalTarget={document.querySelector(
              //   target ? target : "body"
              // )}
            />
          )
        }}
      />
    </div>
  )
}

export default ReferenceType
